import { filter } from './input_filter';
import filterStatus, { countVisible } from './filter_status';

const input = document.getElementById('js-funerarium-search');
const groups = Array.from(
  document.getElementsByClassName('js-funerariums-group'),
);

const groupElSelector = '.js-funerariums-filter';

const announce = filterStatus(input);

input.addEventListener('input', e => {
  filter(groups, groupElSelector)(e);
  announce?.(countVisible(groups, groupElSelector));
});
